import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import "./PrivacyPolicyPage.css";

const sections = [
  {
    title: "Information Collection and Use",
    body: [
      "The Lotus Rice app for mobile devices collects information when you download and use the application. This information may include:",
    ],
    bullets: [
      "Your device's Internet Protocol address (for example, IP address)",
      "The pages of the application that you visit, the time and date of your visit, and the time spent on those pages",
      "The time spent on the application",
      "The operating system you use on your mobile device",
    ],
  },
  {
    title: "Location Data",
    body: [
      "The application may collect your device's location to determine your approximate geographical location and use it for the following purposes:",
    ],
    bullets: [
      "Geolocation services to provide personalized content, relevant recommendations, and location-based services",
      "Analytics and improvements using aggregated and anonymized location data to analyze behavior, identify trends, and improve the application's performance and functionality",
      "Third-party services that may periodically receive anonymized location data to help enhance the application and optimize offerings",
    ],
  },
  {
    title: "AI Features",
    body: [
      "The application uses Artificial Intelligence (AI) technologies to enhance user experience and provide certain features. AI components may process user data to deliver personalized content, recommendations, or automated functionality. All AI processing is performed in accordance with this privacy policy and applicable laws. If you have questions about AI features or data processing, contact the Service Provider.",
    ],
  },
  {
    title: "Communications",
    body: [
      "The Service Provider may use the information you provide to contact you from time to time with important information, required notices, and marketing promotions.",
    ],
  },
  {
    title: "Personally Identifiable Information",
    body: [
      "For a better experience, while using the application, the Service Provider may require certain personally identifiable information, including but not limited to unnatixtechnologies@gmail.com. The information requested will be retained and used as described in this privacy policy.",
    ],
  },
  {
    title: "Third Party Access",
    body: [
      "Only aggregated and anonymized data is periodically transmitted to external services to help the Service Provider improve the application and related services. The Service Provider may share your information with third parties in the ways described in this privacy policy.",
      "The Service Provider may disclose User Provided and Automatically Collected Information:",
    ],
    bullets: [
      "As required by law, such as to comply with a subpoena or similar legal process",
      "When disclosure is necessary in good faith to protect rights, protect your safety or the safety of others, investigate fraud, or respond to a government request",
      "With trusted service providers who work on behalf of the Service Provider, have no independent right to use the disclosed information, and have agreed to follow this privacy policy",
    ],
  },
  {
    title: "Opt-Out Rights",
    body: [
      "You can stop all collection of information by the application by uninstalling it. You may use the standard uninstall processes available on your mobile device or through the mobile application marketplace or network.",
    ],
  },
  {
    title: "Data Retention Policy",
    body: [
      "The Service Provider will retain User Provided data for as long as you use the application and for a reasonable time afterward. If you would like User Provided Data deleted, contact lotusriceindustries@gmail.com and the Service Provider will respond within a reasonable time.",
    ],
  },
  {
    title: "Children",
    body: [
      "The Service Provider does not use the application to knowingly solicit data from or market to children under the age of 13.",
      "The Service Provider does not knowingly collect personally identifiable information from children. Children should never submit personally identifiable information through the application or services, and parents or guardians are encouraged to monitor online activity. If you believe a child has provided personally identifiable information through the application or services, contact lotusriceindustries@gmail.com so that necessary action can be taken.",
      "You must also be at least 16 years of age to consent to the processing of your personally identifiable information in your country. In some countries, a parent or guardian may provide consent on your behalf.",
    ],
  },
  {
    title: "Security",
    body: [
      "The Service Provider is concerned about safeguarding the confidentiality of your information and uses physical, electronic, and procedural safeguards to protect information processed and maintained through the application.",
    ],
  },
  {
    title: "Changes",
    body: [
      "This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of changes by updating this page. Continued use of the application is considered approval of the updated policy.",
    ],
  },
  {
    title: "Your Consent",
    body: [
      "By using the application, you consent to the processing of your information as set forth in this Privacy Policy, now and as amended in the future.",
    ],
  },
  {
    title: "Contact Us",
    body: [
      "If you have questions regarding privacy while using the application or about the practices, contact the Service Provider via email at lotusriceindustries@gmail.com.",
    ],
  },
];

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-page__backdrop" />

      <header className="privacy-page__topbar">
        <Link to="/login" className="privacy-page__brand">
          <img src={logo} alt="Lotus Rice Mill Pvt. Ltd." />
          <span>Lotus Rice Mill Pvt. Ltd.</span>
        </Link>
        <Link to="/login" className="privacy-page__login-link">
          Back to Login
        </Link>
      </header>

      <main className="privacy-page__main">
        <section className="privacy-page__hero">
          <p className="privacy-page__eyebrow">Public Legal Page</p>
          <h1>Privacy Policy</h1>
          <p className="privacy-page__summary">
            This privacy policy applies to the Lotus Rice app for mobile devices,
            created by Ankush Kumar as a free service and provided on an &quot;AS IS&quot; basis.
          </p>
          <div className="privacy-page__meta">
            <span>Service Provider: Ankush Kumar</span>
            <span>Effective Date: April 10, 2026</span>
          </div>
        </section>

        <section className="privacy-page__content">
          {sections.map((section) => (
            <article key={section.title} className="privacy-page__card">
              <h2>{section.title}</h2>
              {section.body?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.bullets?.length ? (
                <ul>
                  {section.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </article>
          ))}
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
